import React, { Component } from "react";
import Data from "../views/Data";
import Overview from "../views/Overview";
import Articles from "../views/Articles";
import Images from "../views/Images";
import { Menu } from "antd";
import { Layout } from "antd";
import {
  DashboardOutlined,
  ReadOutlined,
  AppstoreOutlined,
  DatabaseOutlined,
} from "@ant-design/icons";

const { Sider, Content } = Layout;

export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSection: "overview",
    };
  }

  // Side menu sections
  items = [
    {
      key: "overview",
      label: "Overview",
      icon: <DashboardOutlined />,
    },
    {
      key: "articles",
      label: "Articles",
      icon: <ReadOutlined />,
    },
    {
      key: "images",
      label: "Images",
      icon: <AppstoreOutlined />,
    },
    {
      key: "data",
      label: "Change data",
      icon: <DatabaseOutlined />,
    },
  ];

  changeSection = (value) => {
    this.setState({
      activeSection: value.key,
    });
  };

  // Render the selected section
  renderSection = (value) => {
    switch (value) {
      case "data":
        return <Data></Data>;
      case "overview":
        return (
          <Overview
            data={window.$data}
            imagesData={window.$imageData}
            changeSection={this.changeSection}
          ></Overview>
        );
      case "articles":
        return <Articles data={window.$data}></Articles>;
      case "images":
        return <Images data={window.$imageData}></Images>;
    }
  };

  render() {
    const { activeSection } = this.state;

    if (window.$data == "data") {
      return <Data></Data>;
    }
    return (
      <Layout>
        <Sider theme="light">
          <Menu
            onClick={this.changeSection}
            style={{ width: 200, position: "sticky", top: "0", border: "none" }}
            selectedKeys={activeSection}
            mode="inline"
            items={this.items}
          />
        </Sider>
        <Content>{this.renderSection(activeSection)}</Content>
      </Layout>
    );
  }
}
